import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DATE_FORMAT } from "../app/contants";

function DateField(props) {
	const { idPrefix, schema, name, required, readonly, formData, onChange } = props;
	const [startDate, setStartDate] = useState();
	const { title } = schema;

	useEffect(() => {
		setStartDate(moment(formData).toDate())
	}, [formData]);

	useEffect(() => {
		onChange(moment(startDate).format(DATE_FORMAT));
	}, [startDate]);

	function handleChange(date) {
		setStartDate(date);
	}

	return (
		<React.Fragment>
			<label className="form-label">{title}{required && '*'}</label>
			<div className="form-group">
				<DatePicker
					id={`${idPrefix}_${name}`}
					className="form-control"
					dateFormat="MM/dd/yyyy"
					placeholderText='mm/dd/yyyy'
					readOnly={readonly}
					showMonthDropdown
					showYearDropdown
					dropdownMode="select"
					selected={startDate}
					autoComplete="new-date"
					onKeyDown={(e) => e.preventDefault()}
					onChange={(date) => handleChange(date)}
				/>
			</div>
		</React.Fragment>
	)
}

export default DateField;